'use client';

import { CONFIG, POSTHOG_PUBLIC_KEY } from '@/core/config';
import dynamic from 'next/dynamic';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const PostHogPageView = dynamic(() => import('./PostHogPageView'), {
    ssr: false,
  });

  useEffect(() => {
    if (
      CONFIG.BASE_URL.includes('localhost') ||
      CONFIG.BASE_URL.includes('dev.prenuvo.dev') ||
      CONFIG.BASE_URL.includes('staging')
    ) {
      return;
    }
    posthog.init(POSTHOG_PUBLIC_KEY, {
      api_host: 'https://us.i.posthog.com',
      capture_pageview: false,
      capture_pageleave: true,
    });
  }, []);

  // PostHog can be accessed throughout our Next.js app by using the usePostHog hook.
  return (
    <PHProvider client={posthog}>
      <PostHogPageView />
      {children}
    </PHProvider>
  );
}
